import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PerfilService } from '../../../shared/services/apis/usuario-admin/perfil.service';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { ListaRelatorioResponse } from '../../../shared/services/responses/relatorio-interno/lista-relatorio.response';
import { ListaPerfilResponse } from '../../../shared/services/responses/usuario-admin/lista-perfil.response';
import { ListaPerfilStruct } from '../../../shared/services/structs/usuario-admin/lista-perfil.struct';
import { MatSelectModule } from '@angular/material/select';
import { RelatorioPerfilRequest } from '../../../shared/services/requests/relatorio-interno/relatorio-rerfil.request';
import { ConfigurarRelatorioService } from '../../../shared/services/apis/relatorio-interno/configurar-relatorio.service';
import { PerfilEnum } from '../../../shared/enums/perfil.enum';
import { UsuarioAdminLookupResponse } from '../../../shared/services/responses/usuario-admin/usuario-admin-lookup.response';
import { UsuarioAdminService } from '../../../shared/services/apis/usuario-admin/usuario-admin.service';
import { RelatorioNomePerfilStruct } from '../../../shared/services/structs/relatorio-interno/relatorio-nome-perfil.strcut';
import { NomePerfilPipe } from '../../../shared/pipes/nome-perfil.pipe';
import { PermissaoEnum } from '../../../shared/enums/permissao.enum';
import { TemPermissaoDirective } from '../../../shared/directives/habilita-por-permissao.directive';

@Component({
  selector: 'app-configurar-relatorio',
  imports: [
    MenuComponent,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    ReactiveFormsModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatSelectModule,
    NomePerfilPipe,
    TemPermissaoDirective,
  ],
  templateUrl: './configurar-relatorio.component.html',
  styleUrl: './configurar-relatorio.component.css',
})
export class ConfigurarRelatorioComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private configurarRelatorioService: ConfigurarRelatorioService,
    private perfilService: PerfilService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private usuarioAdminService: UsuarioAdminService
  ) {
    this.moduloEnum = ModuloEnum.InteligenciaDados;
    this.funcionalidadeEnum = FuncionalidadeEnum.InteligenciaDados_ConfigurarRelatorio;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaRelatorioResponse: ListaRelatorioResponse | undefined;
  public _listaPerfilStruct: ListaPerfilResponse | undefined;
  public _listaRelatorioNomePerfil: RelatorioNomePerfilStruct[];
  public _usuarioLookupResponse: UsuarioAdminLookupResponse;
  public displayedColumns: string[] = [
    'idRelatorio',
    'tituloRelatorio',
    'perfilAcesso',
    'action-edit',
    'action-delete',
  ];
  public _dataSource = new MatTableDataSource<RelatorioPerfilRequest>();
  public _dataSourcePerfil = new MatTableDataSource<ListaPerfilStruct>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public _perfilSelect: FormControl = new FormControl('');
  public _perfilSelectOptions: ListaPerfilStruct[] = [];
  public _enumPerfil = PerfilEnum;
  public _PermissaoEnum = PermissaoEnum;

  async ngOnInit(): Promise<void> {
    this.model = this.formBuilder.group({
      tituloRelatorio: [''],
      perfilAcesso: [''],
    });

    await this.popularLookup();
    await this.pesquisar();
  }

  async popularLookup(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.usuarioAdminService.Lookup().subscribe({
        next: (usuarioLookupResponse: UsuarioAdminLookupResponse) => {
          if (usuarioLookupResponse.isError) {
            this.alertService.show('Erro', usuarioLookupResponse.errorDescription, AlertType.error);
            return;
          }

          this._usuarioLookupResponse = {
            errorCode: usuarioLookupResponse.errorCode,
            errorDescription: usuarioLookupResponse.errorDescription,
            isError: usuarioLookupResponse.isError,
            listaPerfil: usuarioLookupResponse.listaPerfil,
          };
          resolve();
        },
        error: (error: any) => {
          this.alertService.show('Erro inesperado', error.message, AlertType.error);
          reject(error);
        },
      });
    });
  }

  async pesquisar(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (this.model.invalid || this._isLoading === true) {
        return;
      }

      this._isLoading = true;
      const titulo: string = this.model.get('tituloRelatorio')?.value.trim();

      const perfilAcessoPesquisar: string[] = this._perfilSelect.value;

      this.configurarRelatorioService
        .get(titulo, perfilAcessoPesquisar.toString(), this._paginaAtual)
        .subscribe({
          next: (relatorioResponse: ListaRelatorioResponse) => {
            this._isLoading = false;
            if (relatorioResponse.isError) {
              this.alertService.show('Erro', relatorioResponse.errorDescription, AlertType.error);
              return;
            }

            this._ultimaPagina = true;

            if (!this._listaRelatorioResponse) {
              this._listaRelatorioResponse = relatorioResponse;
              this._ultimaPagina = false;
            } else if (relatorioResponse.listaRelatorioPerfil?.length > 0) {
              this._listaRelatorioResponse.listaRelatorioPerfil.push(
                ...relatorioResponse.listaRelatorioPerfil
              );
              this._ultimaPagina = false;
            }
            this._dataSource.data = this._listaRelatorioResponse.listaRelatorioPerfil;

            this._listaRelatorioNomePerfil = this._listaRelatorioResponse.listaRelatorioPerfil.map(
              relatorioPerfil => {
                const perfis = this._usuarioLookupResponse.listaPerfil.filter(perfil =>
                  relatorioPerfil.listaIdPerfil.includes(perfil.idPerfil)
                );

                return {
                  idRelatorioPerfil: relatorioPerfil.idRelatorioPerfil,
                  relatorio: relatorioPerfil.relatorio,
                  listaPerfil: perfis,
                  listaIdPerfil: relatorioPerfil.listaIdPerfil,
                } as RelatorioNomePerfilStruct;
              }
            );

            resolve();
          },
          error: (error: any) => {
            this.alertService.show('Erro inesperado', error.message, AlertType.error);
            this._isLoading = false;
            reject(error);
          },
        });
    });
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaRelatorioResponse = undefined;
    this.pesquisar();
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  abrirModalExcluir(idRelatorio: number, tituloRelatorio: string): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Alerta',
        description: `Deseja excluir o relatório "${tituloRelatorio}"? Essa ação será irreversível.`,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) this.excluir(idRelatorio);
      },
    });
  }

  private excluir(idRelatorio: number): void {
    this.configurarRelatorioService.excluir(idRelatorio).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.clickPesquisar();

        this.alertService.show('Sucesso', 'Usuário excluido com sucesso', AlertType.success);
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }
}
